var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.auth.show && !_vm.hidePopup,
          expression: "auth.show && !hidePopup"
        }
      ],
      staticClass: "lite_popup add_drive"
    },
    [
      _c("div", { staticClass: "lite_popup_box lite_add_drive_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _vm.auth.type == "Website"
            ? _c("span", [_vm._v(_vm._s(_vm.$t("language.common.addWebsite")))])
            : _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.auth.did
                      ? _vm.$t("language.leftBanner.edit")
                      : _vm.$t("language.common.addCloud")
                  )
                )
              ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: { click: _vm.close }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content" },
          [
            _c("div", { staticClass: "add_drive_type" }, [
              _c("div", {
                staticClass: "add_drive_icon",
                class: "drive-icon-" + _vm.auth.type
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.cloudTypeToName(_vm.auth.type)))]),
              _vm._v(" "),
              _vm.auth.type == "ICloudPhotos"
                ? _c("div", { staticClass: "add_drive_tip_icloudphotos" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.popup.addCloudPopup.iCloudPhotosTip")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.addCloudPopup.iCloudPhotosTip1"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top", effect: "light" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("font", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "language.popup.addCloudPopup.iCloudPhotosTip1Q"
                                      )
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon-util question-mark plus_icloudphotos_tips_icon"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.addCloudPopup.iCloudPhotosTip2"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "3. " +
                          _vm._s(
                            _vm.$t(
                              "language.popup.addCloudPopup.iCloudDomainTip"
                            )
                          )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "GooglePhotos"
                ? _c("div", { staticClass: "add_drive_tip_googlephotos" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("language.popup.tips")))]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.cloudExploerPopup.googlePhotosV2TipsDesc"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("ol", [
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.cloudExploerPopup.googlePhotosV2Tips1"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.cloudExploerPopup.googlePhotosV2Tips2"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.cloudExploerPopup.googlePhotosV2Tips3"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.cloudExploerPopup.googlePhotosV2Tips4"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "GoogleDrive"
                ? _c("div", { staticClass: "add_drive_tip_googledrive" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.addCloudPopup.googleDrive2FATip"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.addCloudPopup.googleDrive2FATip1"
                          )
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "Egnyte"
                ? _c("div", { staticClass: "add_drive_tip_egnyte" }, [
                    _c("div", { staticClass: "egnyte_tip_title" }, [
                      _vm._v("Create an Egnyte App before connecting:")
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              { attrs: { model: _vm.auth, "label-width": "110px" } },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { display: "none" },
                    attrs: { label: _vm.$t("language.common.type") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.auth.type,
                        callback: function($$v) {
                          _vm.$set(_vm.auth, "type", $$v)
                        },
                        expression: "auth.type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showAppSelection
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("language.liteApp.selectApp") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "lite_add_drive_select",
                            model: {
                              value: _vm.auth.aid,
                              callback: function($$v) {
                                _vm.$set(_vm.auth, "aid", $$v)
                              },
                              expression: "auth.aid"
                            }
                          },
                          [
                            _vm.auth.systemAppAvailable
                              ? _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "language.liteApp.defaultApp"
                                    ),
                                    value: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.auth.customApps, function(app) {
                              return _c("el-option", {
                                key: app.id,
                                attrs: { label: app.name, value: app.id }
                              })
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "lite_add_drive_app_tip" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.liteApp.selectAppTip"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": /AmazonS3|Wasabi|Egnyte/.test(
                        _vm.auth.type
                      )
                        ? "160px"
                        : "110px",
                      label:
                        _vm.auth.type == "Website"
                          ? _vm.$t("language.common.websiteName")
                          : _vm.$t("language.popup.addCloudPopup.displayName")
                    }
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.auth.name,
                        callback: function($$v) {
                          _vm.$set(_vm.auth, "name", $$v)
                        },
                        expression: "auth.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.auth.type == "AmazonS3"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.accessKeyId"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.amazons3.accessKeyId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.amazons3,
                                    "accessKeyId",
                                    $$v
                                  )
                                },
                                expression: "auth.amazons3.accessKeyId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.secretAccessKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.auth.did != null,
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.amazons3.secretAccessKey,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.amazons3,
                                    "secretAccessKey",
                                    $$v
                                  )
                                },
                                expression: "auth.amazons3.secretAccessKey"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.bucketOptional"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.amazons3.bucket,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.amazons3, "bucket", $$v)
                                },
                                expression: "auth.amazons3.bucket"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.regionOptional"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.amazons3.region,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.amazons3, "region", $$v)
                                },
                                expression: "auth.amazons3.region"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.endpointOptional"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.amazons3.endpoint,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.amazons3, "endpoint", $$v)
                                },
                                expression: "auth.amazons3.endpoint"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "Egnyte"
                  ? _c(
                      "div",
                      { staticClass: "egnyte_form" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t("language.popup.domain")
                            }
                          },
                          [
                            _c("span", { staticClass: "egnyte_prefix" }, [
                              _vm._v("https://")
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "egnyte_domain",
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.egnyte.domain,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.egnyte, "domain", $$v)
                                },
                                expression: "auth.egnyte.domain"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "egnyte_suffix" }, [
                              _vm._v(".egnyte.com")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.accessKeyId"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.egnyte.accessKeyId,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.egnyte, "accessKeyId", $$v)
                                },
                                expression: "auth.egnyte.accessKeyId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.secretAccessKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.auth.did != null,
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.egnyte.secretAccessKey,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.egnyte,
                                    "secretAccessKey",
                                    $$v
                                  )
                                },
                                expression: "auth.egnyte.secretAccessKey"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t("language.popup.email")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.egnyte.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.egnyte, "email", $$v)
                                },
                                expression: "auth.egnyte.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.egnyte.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.egnyte, "password", $$v)
                                },
                                expression: "auth.egnyte.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "Wasabi"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.accessKeyId"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.wasabi.accessKeyId,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.wasabi, "accessKeyId", $$v)
                                },
                                expression: "auth.wasabi.accessKeyId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "160px",
                              label: _vm.$t(
                                "language.popup.addCloudPopup.secretAccessKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.auth.did != null,
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.wasabi.secretAccessKey,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.wasabi,
                                    "secretAccessKey",
                                    $$v
                                  )
                                },
                                expression: "auth.wasabi.secretAccessKey"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "ICloudPhotos" ||
                _vm.auth.type == "ICloudDrive"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.domain") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "lite_add_drive_select",
                                attrs: {
                                  disabled:
                                    _vm.auth.did != null ||
                                    _vm.auth.icloud.sessionId != ""
                                },
                                model: {
                                  value: _vm.auth.icloud.domain,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth.icloud, "domain", $$v)
                                  },
                                  expression: "auth.icloud.domain"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "www.icloud.com",
                                    value: "com"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "www.icloud.com.cn",
                                    value: "cn"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.appleId"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  _vm.auth.did != null ||
                                  _vm.auth.icloud.sessionId != ""
                              },
                              model: {
                                value: _vm.auth.icloud.appleId,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.icloud, "appleId", $$v)
                                },
                                expression: "auth.icloud.appleId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password",
                                disabled: _vm.auth.icloud.sessionId != ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.icloud.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.icloud, "password", $$v)
                                },
                                expression: "auth.icloud.password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.auth.icloud.sessionId != ""
                          ? _c(
                              "div",
                              { staticClass: "icloud_code_div" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("language.popup.code")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "code_input",
                                      attrs: { maxlength: "6" },
                                      model: {
                                        value: _vm.auth.icloud.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.auth.icloud, "code", $$v)
                                        },
                                        expression: "auth.icloud.code"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "send_code_btn",
                                        attrs: {
                                          disabled: _vm.auth.icloud.secs > 0
                                        },
                                        on: { click: _vm.icloudSendCode }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.resendCode"
                                            ) +
                                              (_vm.auth.icloud.secs > 0
                                                ? "(" +
                                                  _vm.auth.icloud.secs +
                                                  "s)"
                                                : "")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "FTP"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.protocol"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "lite_add_drive_select",
                                model: {
                                  value: _vm.auth.ftp.protocol,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth.ftp, "protocol", $$v)
                                  },
                                  expression: "auth.ftp.protocol"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "ftp-plain",
                                    value: "ftp-plain"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "ftps-explicit",
                                    value: "ftps-explicit"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "ftps-implicit",
                                    value: "ftps-implicit"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.ftp.host,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "host", $$v)
                                },
                                expression: "auth.ftp.host"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.port")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.ftp.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "port", $$v)
                                },
                                expression: "auth.ftp.port"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.ftp.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "username", $$v)
                                },
                                expression: "auth.ftp.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.ftp.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "password", $$v)
                                },
                                expression: "auth.ftp.password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passive"
                              )
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "switch-box" },
                              [
                                _c("el-switch", {
                                  attrs: { "active-color": "#5166BD" },
                                  model: {
                                    value: _vm.auth.ftp.passive,
                                    callback: function($$v) {
                                      _vm.$set(_vm.auth.ftp, "passive", $$v)
                                    },
                                    expression: "auth.ftp.passive"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.encoding"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "lite_add_drive_select",
                                model: {
                                  value: _vm.auth.ftp.encoding,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth.ftp, "encoding", $$v)
                                  },
                                  expression: "auth.ftp.encoding"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "ISO-8859-1",
                                    value: "ISO-8859-1"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "UTF-8", value: "UTF-8" }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "GBK", value: "GBK" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.path")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.path,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "path", $$v)
                                },
                                expression: "auth.ftp.path"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "SFTP"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.sftp.host,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "host", $$v)
                                },
                                expression: "auth.sftp.host"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.port")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.sftp.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "port", $$v)
                                },
                                expression: "auth.sftp.port"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.sftp.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "username", $$v)
                                },
                                expression: "auth.sftp.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.sftp.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "password", $$v)
                                },
                                expression: "auth.sftp.password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.privateKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.auth.sftp.privateKey,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "privateKey", $$v)
                                },
                                expression: "auth.sftp.privateKey"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passphrase"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.sftp.passphrase,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "passphrase", $$v)
                                },
                                expression: "auth.sftp.passphrase"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.path")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.path,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "path", $$v)
                                },
                                expression: "auth.sftp.path"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "WebDAV"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.webdav.url,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "url", $$v)
                                },
                                expression: "auth.webdav.url"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.webdav.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "username", $$v)
                                },
                                expression: "auth.webdav.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.webdav.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "password", $$v)
                                },
                                expression: "auth.webdav.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "MySQL"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.mysql.host,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mysql, "host", $$v)
                                },
                                expression: "auth.mysql.host"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.port")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.mysql.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mysql, "port", $$v)
                                },
                                expression: "auth.mysql.port"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.mysql.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mysql, "username", $$v)
                                },
                                expression: "auth.mysql.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.mysql.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mysql, "password", $$v)
                                },
                                expression: "auth.mysql.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "Backblaze"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.keyID"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.auth.did != null },
                              model: {
                                value: _vm.auth.backblaze.applicationKeyId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.backblaze,
                                    "applicationKeyId",
                                    $$v
                                  )
                                },
                                expression: "auth.backblaze.applicationKeyId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.applicationKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.auth.did != null,
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.backblaze.applicationKey,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auth.backblaze,
                                    "applicationKey",
                                    $$v
                                  )
                                },
                                expression: "auth.backblaze.applicationKey"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "MediaFire"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.mediafire.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mediafire, "email", $$v)
                                },
                                expression: "auth.mediafire.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.mediafire.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mediafire, "password", $$v)
                                },
                                expression: "auth.mediafire.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "SugarSync"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sugarsync.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sugarsync, "email", $$v)
                                },
                                expression: "auth.sugarsync.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.sugarsync.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sugarsync, "password", $$v)
                                },
                                expression: "auth.sugarsync.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "MEGA"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.mega.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mega, "email", $$v)
                                },
                                expression: "auth.mega.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: _vm.showPassword ? "text" : "password"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function() {
                                      return [
                                        _c("div", {
                                          class: _vm.showPassword
                                            ? "open_eye"
                                            : "close_eye",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                649742133
                              ),
                              model: {
                                value: _vm.auth.mega.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mega, "password", $$v)
                                },
                                expression: "auth.mega.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "Website"
                  ? _c("div", [
                      _c("div", { staticClass: "website_box" }, [
                        _c("div", { staticClass: "website_box_title" }, [
                          _c("div", { staticClass: "website_box_title_text" }, [
                            _vm._v(_vm._s(_vm.$t("language.website.addSite")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "website_box_title_add",
                              on: {
                                click: function($event) {
                                  return _vm.addSite()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.website.addSiteMore"))
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "website_items myscroll" },
                          _vm._l(_vm.auth.website.sites, function(site, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "website_item2 website_item_site"
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "language.popup.addCloudPopup.server"
                                        ) +
                                        " " +
                                        (index + 1)
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "website_host_prefix" },
                                      [_vm._v("sftp://")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "website_host",
                                      model: {
                                        value: site.host,
                                        callback: function($$v) {
                                          _vm.$set(site, "host", $$v)
                                        },
                                        expression: "site.host"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "website_port",
                                      model: {
                                        value: site.port,
                                        callback: function($$v) {
                                          _vm.$set(site, "port", $$v)
                                        },
                                        expression: "site.port"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "language.popup.addCloudPopup.userName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: site.username,
                                        callback: function($$v) {
                                          _vm.$set(site, "username", $$v)
                                        },
                                        expression: "site.username"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "language.popup.addCloudPopup.passWord"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: _vm.showPassword
                                          ? "text"
                                          : "password"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "suffix",
                                            fn: function() {
                                              return [
                                                _c("div", {
                                                  class: _vm.showPassword
                                                    ? "open_eye"
                                                    : "close_eye",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showPassword = !_vm.showPassword
                                                    }
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: site.password,
                                        callback: function($$v) {
                                          _vm.$set(site, "password", $$v)
                                        },
                                        expression: "site.password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "website_more" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "website_more_btn",
                                      class: site.show ? "open" : "close",
                                      on: {
                                        click: function($event) {
                                          site.show = !site.show
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.addCloudPopup.advanced"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "website_more_remove",
                                      on: {
                                        click: function($event) {
                                          return _vm.delSite(index)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.website.removeSite")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: site.show,
                                        expression: "site.show"
                                      }
                                    ],
                                    staticClass: "website_more_content"
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "language.popup.addCloudPopup.privateKey2"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { type: "textarea" },
                                          model: {
                                            value: site.privateKey,
                                            callback: function($$v) {
                                              _vm.$set(site, "privateKey", $$v)
                                            },
                                            expression: "site.privateKey"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "language.popup.addCloudPopup.passphrase"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: _vm.showPassword
                                              ? "text"
                                              : "password"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "suffix",
                                                fn: function() {
                                                  return [
                                                    _c("div", {
                                                      class: _vm.showPassword
                                                        ? "open_eye"
                                                        : "close_eye",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showPassword = !_vm.showPassword
                                                        }
                                                      }
                                                    })
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: site.passphrase,
                                            callback: function($$v) {
                                              _vm.$set(site, "passphrase", $$v)
                                            },
                                            expression: "site.passphrase"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "language.popup.addCloudPopup.path"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: site.path,
                                            callback: function($$v) {
                                              _vm.$set(site, "path", $$v)
                                            },
                                            expression: "site.path"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "website_box" }, [
                        _c("div", { staticClass: "website_box_title" }, [
                          _c("div", { staticClass: "website_box_title_text" }, [
                            _vm._v(_vm._s(_vm.$t("language.website.addDb")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "website_box_title_add",
                              on: {
                                click: function($event) {
                                  return _vm.addDB()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.website.addDbMore"))
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "website_items myscroll" },
                          _vm._l(_vm.auth.website.dbs, function(db, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "website_item2 website_item_db"
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "language.popup.addCloudPopup.server"
                                        ) +
                                        " " +
                                        (index + 1)
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "website_host",
                                      model: {
                                        value: db.host,
                                        callback: function($$v) {
                                          _vm.$set(db, "host", $$v)
                                        },
                                        expression: "db.host"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "website_port",
                                      model: {
                                        value: db.port,
                                        callback: function($$v) {
                                          _vm.$set(db, "port", $$v)
                                        },
                                        expression: "db.port"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "language.popup.addCloudPopup.userName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: db.username,
                                        callback: function($$v) {
                                          _vm.$set(db, "username", $$v)
                                        },
                                        expression: "db.username"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "language.popup.addCloudPopup.passWord"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: _vm.showPassword
                                          ? "text"
                                          : "password"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "suffix",
                                            fn: function() {
                                              return [
                                                _c("div", {
                                                  class: _vm.showPassword
                                                    ? "open_eye"
                                                    : "close_eye",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showPassword = !_vm.showPassword
                                                    }
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: db.password,
                                        callback: function($$v) {
                                          _vm.$set(db, "password", $$v)
                                        },
                                        expression: "db.password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "website_more" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "website_more_btn",
                                      class: db.show ? "open" : "close",
                                      on: {
                                        click: function($event) {
                                          db.show = !db.show
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("language.popup.tips"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "website_more_remove",
                                      on: {
                                        click: function($event) {
                                          return _vm.delDB(index)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.website.removeDb")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: db.show,
                                      expression: "db.show"
                                    }
                                  ],
                                  staticClass: "website_more_content",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "language.popup.addCloudPopup.mySQLTips"
                                      )
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [
              _vm.auth.loading
                ? _c("i", {
                    staticClass: "el-icon-loading",
                    staticStyle: { color: "#fff" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "Website"
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.common.addWebsite")))
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.auth.did
                          ? _vm.$t("language.leftBanner.edit")
                          : _vm.$t("language.common.addCloud")
                      )
                    )
                  ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "\n                            Open\n                            "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://developers.egnyte.com/my-apps",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Egnyte My Apps")]
        ),
        _vm._v(
          "\n                            with an Egnyte domain administrator account, then create a new app.\n                        "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n                            Enter the App Name, Description and Egnyte Domain. For example, enter\n                            "
        ),
        _c("b", [_vm._v("acme")]),
        _vm._v(" if the domain URL is "),
        _c("b", [_vm._v("https://acme.egnyte.com")]),
        _vm._v(".\n                        ")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("\n                            Select "),
        _c("b", [_vm._v("Internal Application (own company use only)")]),
        _vm._v(", "),
        _c("b", [_vm._v("New App")]),
        _vm._v(" and\n                            "),
        _c("b", [_vm._v("Web App")]),
        _vm._v(", then request the "),
        _c("b", [_vm._v("Prod Collaborate")]),
        _vm._v(
          " API. After approval,\n                            enter the domain, API key and secret below.\n                        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c478465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c478465","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_add_drive.vue
// module id = null
// module chunks = 